<div class="mobile-header" *ngIf="isRedirectFormHomePage">
  <a class="back-btn text-white" [routerLink]="['/']">
    <i class="material-icons">arrow_back_ios</i>
  </a>
</div>
<div
  class="how-it-works"
  [class.container]="isRedirectFormHomePage"
  [class.how-it-works-page]="!isModal && !isRedirectFormHomePage"
>
  <div class="how-it-works-main">
    <img [src]="'logos/kings-white.svg' | contentAssetImage" alt="" class="wordmark" />
    <div class="how-it-works-body">
      <div class="intro">
        <div class="title">{{ 'how.it.work.title' | translate }}</div>
        <div class="sub-title" [innerHTML]="'how.it.work.sub.title' | translate | markdownTranslate"></div>
      </div>
      <div class="content">
        <div class="attend-games">
          <div class="material-icons">sports_basketball</div>
          <div class="text">{{ 'how.it.work.attend.game' | translate }}</div>
        </div>
        <div class="rewards">
          <div class="material-icons">local_police</div>
          <div class="text">{{ 'how.it.work.rewards' | translate }}</div>
        </div>
        <div class="redeem">
          <div class="material-icons">phone_iphone</div>
          <div class="text">{{ 'how.it.work.redeem' | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="outro">{{ 'how.it.works.description' | translate }}</div>

  <div class="action-wrapper">
    <button class="btn btn-primary btn-back" (click)="submitStep()">
      <a>
        @if (isModal) {
          {{ 'how.it.work.modal.link' | translate }}
        } @else {
          {{ routerLink | translate }}
        }
      </a>
    </button>
  </div>
</div>
